module.exports = __webpack_public_path__ + "static/media/io.1c01e17a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/io.png
// module id = 1884
// module chunks = 0